'use client';

import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const closeMobileMenu = () => setShowMobileMenu(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <h2>Catering System</h2>
        </div>

        <button
          className="mobile-menu-toggle"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={showMobileMenu}
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`mobile-nav-panel ${showMobileMenu ? 'mobile-open' : ''}`}>
          <ul className="nav-menu">
            {user?.role !== 'employee' && (
              <>
                <li><Link to="/dashboard" onClick={closeMobileMenu}>Dashboard</Link></li>
                <li><Link to="/events" onClick={closeMobileMenu}>Events</Link></li>
                <li><Link to="/expenses" onClick={closeMobileMenu}>Expenses</Link></li>
                <li><Link to="/employees" onClick={closeMobileMenu}>Employees</Link></li>
                {user?.role === 'owner' && <li><Link to="/salaries" onClick={closeMobileMenu}>Salaries</Link></li>}
                <li><Link to="/reports" onClick={closeMobileMenu}>Reports</Link></li>
                <li><Link to="/billing" onClick={closeMobileMenu}>Billing</Link></li>
                <li><Link to="/phone-book" onClick={closeMobileMenu}>Phone Book</Link></li>
                {user?.role === 'owner' && <li><Link to="/users" onClick={closeMobileMenu}>Users</Link></li>}
              </>
            )}
            <li><Link to="/attendance" onClick={closeMobileMenu}>Attendance</Link></li>
          </ul>
        </div>

        <div className="navbar-right">
          <div className="user-dropdown" ref={dropdownRef}>
            <button
              className="user-info-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <span className="user-avatar-icon" aria-hidden="true">👤</span>
              <span className="user-info">{user?.name} ({user?.role})</span>
              <span className="dropdown-arrow">▼</span>
            </button>
            {showDropdown && (
              <div className="dropdown-menu">
                <Link to="/profile" onClick={() => setShowDropdown(false)}>
                  My Profile
                </Link>
                <button onClick={handleLogout} className="logout-link">
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
